/**
 * Subscribed Users master-specific translation keys
 */
export const subscribedUser = {
  list: {
    main_heading: "admin.subscribed_user_list_heading",
    search_placeholder: "admin.subscribed_user_search_placeholder",
    table: {
      purchase_date_col_heading: "admin.subscribed_user_table_purchase_date_col_heading",
      user_name_col_heading: "admin.subscribed_user_table_user_name_col_heading",
      email_col_heading: "admin.subscribed_user_table_email_col_heading",
      plan_name_col_heading: "admin.subscribed_user_table_plan_name_col_heading",
      amount_paid_col_heading: "admin.subscribed_user_table_amount_paid_col_heading",
      expiry_date_col_heading: "admin.subscribed_user_table_expiry_date_col_heading",
      auto_renew_col_heading: "admin.subscribed_user_table_auto_renew_col_heading",
      status_col_heading: "admin.subscribed_user_table_status_col_heading",
      action_col_heading: "admin.subscribed_user_table_action_col_heading",
    },
    plan_filter_placeholder: "admin.subscribed_user_plan_filter_placeholder",
    user_type_filter: {
      all: "admin.subscribed_user_user_type_filter_all",
    },
    status_filter: {
      all: "admin.subscribed_user_status_filter_all",
      active: "admin.subscribed_user_status_active",
      expired: "admin.subscribed_user_status_expired",
      cancelled: "admin.subscribed_user_status_cancelled",
    },
    auto_renew: {
      yes: "admin.subscribed_user_auto_renew_yes",
      no: "admin.subscribed_user_auto_renew_no",
    },
    date_from_placeholder: "admin.subscribed_user_date_from_placeholder",
    date_to_placeholder: "admin.subscribed_user_date_to_placeholder",
    clear_filter_btn_text: "admin.subscribed_user_clear_filter_btn_text",
    view_tooltip: "admin.subscribed_user_view_tooltip",
    defaults: {
      na: "admin.subscribed_user_defaults_na",
    },
  },
  view: {
    main_heading: "admin.subscribed_user_view_heading",
    back_to_list: "admin.subscribed_user_back_to_list",
    error: {
      not_found: "admin.subscribed_user_not_found_heading",
      not_found_description: "admin.subscribed_user_not_found_description",
    },
    tabs: {
      subscription_info: "admin.subscribed_user_tab_subscription_info",
      transaction_history: "admin.subscribed_user_tab_transaction_history",
      verification: "admin.subscribed_user_tab_verification",
    },
    // Subscription Status badge labels (active/expired/cancelled) — shares the same
    // wording/keys as the list page's status filter options.
    subscription_status: {
      active: "admin.subscribed_user_status_active",
      expired: "admin.subscribed_user_status_expired",
      cancelled: "admin.subscribed_user_status_cancelled",
    },
    subscription_info: {
      title: "admin.subscribed_user_subscription_info_title",
      plan_name_label: "admin.subscribed_user_plan_name_label",
      duration_label: "admin.subscribed_user_duration_label",
      amount_paid_label: "admin.subscribed_user_amount_paid_label",
      purchase_date_label: "admin.subscribed_user_purchase_date_label",
      expiry_date_label: "admin.subscribed_user_expiry_date_label",
      auto_renew_label: "admin.subscribed_user_auto_renew_label",
      payment_method_label: "admin.subscribed_user_payment_method_label",
    },
    transaction_history: {
      title: "admin.subscribed_user_transaction_history_title",
      table: {
        plan_name_col_heading: "admin.subscribed_user_transaction_table_plan_name_col_heading",
        date_time_col_heading: "admin.subscribed_user_transaction_table_date_time_col_heading",
        status_col_heading: "admin.subscribed_user_transaction_table_status_col_heading",
        amount_col_heading: "admin.subscribed_user_transaction_table_amount_col_heading",
      },
    },
    defaults: {
      na: "admin.subscribed_user_defaults_na",
    },
    // Profile verification review (WEAL-466) - approve/reject a Premium user's uploaded
    // documents to mark their profile verified. Works for both plan contexts (Normal user's
    // UserDocument/UserProfile, Business/Local's FreelancerDocument/FreelancerProfile) - the
    // API resolves which one applies from the subscription itself.
    verification: {
      title: "admin.subscribed_user_verification_title",
      status_label: "admin.subscribed_user_verification_status_label",
      status: {
        not_submitted: "admin.subscribed_user_verification_status_not_submitted",
        pending: "admin.subscribed_user_verification_status_pending",
        approved: "admin.subscribed_user_verification_status_approved",
        rejected: "admin.subscribed_user_verification_status_rejected",
      },
      rejection_reason_label: "admin.subscribed_user_verification_rejection_reason_label",
      no_documents: "admin.subscribed_user_verification_no_documents",
      document_type: {
        public: "admin.subscribed_user_verification_document_type_public",
        private: "admin.subscribed_user_verification_document_type_private",
      },
      actions: {
        approve: "admin.subscribed_user_verification_approve_btn",
        reject: "admin.subscribed_user_verification_reject_btn",
      },
      approve_popup: {
        heading: "admin.subscribed_user_verification_approve_popup_heading",
        message: "admin.subscribed_user_verification_approve_popup_message",
        yes_btn_text: "admin.subscribed_user_verification_approve_popup_yes_btn_text",
        no_btn_text: "admin.subscribed_user_verification_approve_popup_no_btn_text",
      },
      reject_popup: {
        heading: "admin.subscribed_user_verification_reject_popup_heading",
        message: "admin.subscribed_user_verification_reject_popup_message",
        reason_placeholder: "admin.subscribed_user_verification_reject_reason_placeholder",
        reason_required: "admin.subscribed_user_verification_reject_reason_required",
        yes_btn_text: "admin.subscribed_user_verification_reject_popup_yes_btn_text",
        no_btn_text: "admin.subscribed_user_verification_reject_popup_no_btn_text",
      },
      messages: {
        approve_success: "admin.subscribed_user_verification_approve_success",
        reject_success: "admin.subscribed_user_verification_reject_success",
      },
    },
  },
};
